// @flow
import styled from "styled-components"

export const PromoCodeLinkWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  width: 100%;
  padding: 0 2.4rem;
  margin: 1.2rem 0;
  cursor: pointer;
  border: 0.1rem solid ${(props) => props.theme.color.light};
`;



// WEBPACK FOOTER //
// ./src/pages/Checkout/CheckoutForm/PromoCodeLink/styled.js